var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineUpF1DefaultCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2783 17.953L31.0798 20.6484L30.8824 19.47L33.8934 17.5047L33.8934 17.2378L30.6242 17.2378L30.6242 15.9475L34.2783 16.223L34.2783 17.953Z",
    fill: "#3D455C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0823 17.953L28.2808 20.6484L28.4782 19.47L25.4672 17.5047L25.4672 17.2378L28.7363 17.2378L28.7363 15.9475L25.0823 16.223L25.0823 17.953Z",
    fill: "#3D455C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.6,
    height: 4.8,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.7585 20.8008)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.6,
    height: 4.8,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.7585 52)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7585,
    y: 20.8008,
    width: 6.6,
    height: 4.8,
    transform: "rotate(-90 20.7585 20.8008)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7585,
    y: 52,
    width: 6.6,
    height: 4.8,
    transform: "rotate(-90 20.7585 52)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4.8,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.7585 20.8008)",
    fill: "#3D455C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4.8,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.7585 52)",
    fill: "#3D455C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7585,
    y: 20.8008,
    width: 2,
    height: 4.8,
    transform: "rotate(-90 20.7585 20.8008)",
    fill: "#3D455C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7585,
    y: 52,
    width: 2,
    height: 4.8,
    transform: "rotate(-90 20.7585 52)",
    fill: "#3D455C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0471 13.0697L21.0471 8.61944L28.0597 6.26342C28.4193 6.17616 29.3003 6.00164 29.9476 6.00164L29.9476 9.143L28.3294 9.143L25.0928 10.7137C24.6433 10.9755 24.014 11.499 23.4745 12.0226C23.0481 12.4365 21.8563 13.0697 21.0471 13.0697ZM38.8482 13.0697L38.8482 8.61944L31.8356 6.26342C31.476 6.17616 30.595 6.00164 29.9476 6.00164L29.9476 9.143L31.5659 9.143L34.8025 10.7137C35.252 10.9755 35.8813 11.499 36.4208 12.0226C36.8472 12.4365 38.039 13.0697 38.8482 13.0697Z",
    fill: "#F20D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8482 9.94812L38.8482 8.61999L31.8356 6.26397C31.476 6.17672 30.595 6.00219 29.9476 6.00219C29.3003 6.00219 28.4193 6.17672 28.0597 6.26397L21.0471 8.62L21.0471 9.94812L28.0597 7.5921C28.4193 7.50484 29.3003 7.33032 29.9476 7.33032C30.595 7.33032 31.476 7.50484 31.8356 7.5921L38.8482 9.94812Z",
    fill: "#910808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.0681L20 8.61785L21.0471 8.61785L21.0471 13.0681L20 13.0681Z",
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8481 13.0681L38.8481 8.61785L39.8953 8.61785L39.8953 13.0681L38.8481 13.0681Z",
    fill: "#FFBF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9476 52.8579L25.2078 52.8579L25.2078 46.837L25.7345 46.3134L25.7345 44.3985L24.1546 44.3985C23.4524 39.6865 22.4166 30.1354 23.8912 26.1563C24.1546 25.371 24.6813 24.8474 25.2079 24.5857C25.6292 24.3762 28.5433 23.1022 29.9476 22.4914C31.352 23.1022 34.2661 24.3762 34.6874 24.5857C35.214 24.8474 35.7407 25.371 36.004 26.1563C37.4786 30.1354 36.4429 39.6865 35.7407 44.3985L34.1608 44.3985L34.1608 46.3134L34.6874 46.837L34.6874 52.8579L29.9476 52.8579Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.011 26.4172L24.0745 27.2025C23.1847 27.5516 21.7788 29.8203 23.2737 36.1031C23.7008 38.1973 24.1636 40.117 24.3415 40.8151C24.4305 41.5132 25.0356 42.9094 26.7441 42.9094C26.9576 43.9565 27.189 45.2654 27.278 45.7889L27.278 48.9303L29.9475 48.9303L32.617 48.9303L32.617 45.7889C32.706 45.2654 32.9374 43.9565 33.1509 42.9094C34.8594 42.9094 35.4645 41.5132 35.5535 40.8151C35.7315 40.117 36.1942 38.1973 36.6213 36.1031C38.1163 29.8203 36.7103 27.5516 35.8205 27.2025L32.884 26.4172C31.8162 26.1554 31.0153 11.7575 31.0153 9.13972C31.0153 7.04548 30.3035 6.52192 29.9475 6.52192C29.5916 6.52192 28.8797 7.04548 28.8797 9.13972C28.8797 11.7575 28.0789 26.1554 27.011 26.4172Z",
    fill: "#610505"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0153 9.13914C31.0153 11.7569 31.8162 26.1548 32.884 26.4166L27.011 26.4166C28.0788 26.1548 28.8797 11.7569 28.8797 9.13914C28.8797 7.0449 29.5916 6.52134 29.9475 6.52134C30.3034 6.52134 31.0153 7.0449 31.0153 9.13914Z",
    fill: "#F20D0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7441 42.5683C26.9577 43.6746 27.1891 45.0575 27.278 45.6107L27.278 48.9297L30 48.9297L30 28.9297L28 28.9297C27.5814 29.1883 26.7441 30.0071 26.7441 31.2139C26.7441 32.7225 26 34.2124 26 36.3255C26 38.0159 26.4961 41.1917 26.7441 42.5683Z",
    fill: "#F20D0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2559 42.5683C33.0423 43.6746 32.8109 45.0575 32.722 45.6107L32.722 48.9297L30 48.9297L30 28.9297L32 28.9297C32.4186 29.1883 33.2559 30.0071 33.2559 31.2139C33.2559 32.7225 34 34.2124 34 36.3255C34 38.0159 33.5039 41.1917 33.2559 42.5683Z",
    fill: "#F20D0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 35L27.8999 25.5C27.8999 25.2239 28.1238 25 28.3999 25L31.3999 25C31.676 25 31.8999 25.2239 31.8999 25.5L31.8999 35L27.8999 35Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3999 28L29.3999 24.5C29.3999 24.2239 29.6238 24 29.8999 24V24C30.176 24 30.3999 24.2239 30.3999 24.5L30.3999 28L29.3999 28Z",
    fill: "#F20D0D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 30.5538C33 28.5902 31.6569 26.9983 30 26.9983C28.3431 26.9983 27 28.5902 27 30.5538C27 30.7044 27.0079 30.8527 27.0232 30.9983C27.2077 29.6341 28.4701 28.5785 30 28.5785C31.5299 28.5785 32.7923 29.6341 32.9768 30.9983C32.9921 30.8527 33 30.7044 33 30.5538Z",
    fill: "#F20D0D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1006 42.8374L24.4504 35.0578C24.0579 33.0954 23.6513 29.029 24.793 27.0123L24.0748 27.2043C23.1849 27.5534 21.779 29.8222 23.2739 36.1049C23.7011 38.1991 24.1638 40.1188 24.3418 40.8169C24.4185 41.419 24.8792 42.5404 26.1006 42.8374Z",
    fill: "#F20D0D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7949 42.8374L35.4451 35.0578C35.8376 33.0954 36.2442 29.029 35.1025 27.0123L35.8207 27.2043C36.7106 27.5534 38.1165 29.8222 36.6216 36.1049C36.1944 38.1991 35.7317 40.1188 35.5537 40.8169C35.477 41.419 35.0163 42.5404 33.7949 42.8374Z",
    fill: "#F20D0D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7647 56C23.4448 56 23.2072 55.7038 23.2766 55.3915L24.1015 51.6795C24.1523 51.4507 24.3552 51.288 24.5896 51.288L35.3057 51.288C35.5401 51.288 35.743 51.4507 35.7938 51.6795L36.6187 55.3915C36.6881 55.7038 36.4505 56 36.1306 56L23.7647 56Z",
    fill: "#F20D0D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpF1DefaultCar);
export default __webpack_public_path__ + "static/media/line_up_f1_default_car.75e3b81e2387650990170c32da13e2c9.svg";
export { ForwardRef as ReactComponent };